import React from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

interface Props {
  redirectTo: string;
}

export const HardRedirect = ({ redirectTo }: Props) => {
  React.useEffect(() => {
    window.location.replace(redirectTo);
  });

  return (
    <div>
      <p>Redirecting...</p>
    </div>
  );
};

export const SoftRedirect = ({ redirectTo }: Props) => {
  const nav = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    nav({ pathname: redirectTo, search: location?.search });
  }, [nav, redirectTo, location]);

  return null;
};
